export default __webpack_public_path__ + "maps-examples-runtime-toggle-layer-thumbnail-960-a3532131389cacaec9b254e8a604c255.webp";